import { defineComponent } from "vue";
import { mapState } from "pinia";

import {
    CahpsSurveyRecipient,
    CahpsSurveyRecipientEnum
} from "../../../../../../enums/ReferralEnums/CahpsSurveyRecipientEnum";
import { enumToMap } from "../../../../../../common/vue-helpers/modifiers/enum-modifiers";
import { useHospiceConvertToPending } from "../../../store/useHospiceConvertToPending";

import FormSection from "../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";

export default defineComponent({
    components: {
        FormSection
    },
    props: {
        contacts:{
            type: Array<any>,
            default: []
        }
    },
    data() {
        return {
            cahpsSurveyRecipients: enumToMap(CahpsSurveyRecipient),
            cahpsSurveyRecipientEnum: CahpsSurveyRecipientEnum,
        };
    },
    computed: {
        ...mapState(useHospiceConvertToPending, ["accountId", "application", "patientDetails", "patientId"])
    },

    methods: {
        onSelectCahpsSurveyRecipientOption(value: CahpsSurveyRecipientEnum) {
            this.patientDetails.recipientType = value;
            this.patientDetails.recipientId = null;
            this.patientDetails.unsolicitedReason = null;
        }
    }
});
